import { Component } from '@angular/core';

@Component({
  selector: 'web-foodis-section-invoices',
  templateUrl: './section-invoices.component.html',
  styleUrls: ['./section-invoices.component.scss'],
})
export class SectionInvoicesComponent {}
